var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"myimg",attrs:{"src":_vm.notes1},on:{"click":_vm.callcc}})
}
var staticRenderFns = []

export { render, staticRenderFns }